import React from "react";
import {
    MainPageComponent,
    AuthPageComponent,
    ExitSessionPageComponent,
    DiaryPageComponent,
    NotificationsPageComponent,
    StudentAnalyticsPageComponent,
    DiarySectionPageComponent,
    AccountPageComponent,
} from "../components/pages";

export const MainPage = () => <MainPageComponent />;
export const AuthPage = () => <AuthPageComponent />;
export const ExitSessionPage = () => <ExitSessionPageComponent />;
export const DiaryPage = () => <DiaryPageComponent />;
export const NotificationsPage = () => <NotificationsPageComponent />;
export const StudentAnalyticsPage = () => <StudentAnalyticsPageComponent />;
export const DiarySectionPage = () => <DiarySectionPageComponent />;
export const AccountPage = () => <AccountPageComponent />;
